/**  Типы операций для проверки на настройки сбп */
export enum CatalogOperationTypes {
  /** Операция сбп. */
  SBP = 'SBP',

  Any = ''
}
